import React from 'react';
import PropTypes from 'prop-types';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import { REQUEST_TYPES } from '../consts';
import css from './IntegrationIcon.css';

const ICONS = {
    [REQUEST_TYPES.ANALYTICS]: 'chart-line',
    [REQUEST_TYPES.ATTRIBUTION]: 'chart-bar',
    [REQUEST_TYPES.AD_MONETIZATION]: 'speakerphone',
    [REQUEST_TYPES.AUDIENCE]: 'users',
};

const IntegrationIcon = ({ type }) => (
    <div className={css.cardIcon}>
        <Icon name={ICONS[type]} size={IconSizes.SMALL} variant={IconVariants.ACTIVE} interactive={false} />
    </div>
);

IntegrationIcon.propTypes = {
    type: PropTypes.string.isRequired,
};

export default IntegrationIcon;
